module.exports = __webpack_public_path__ + "static/media/lock.fb1a7195.svg";